import { httpCreate } from './http';

const http = httpCreate('/shop/api/phy-store-group');

export const phyStoreGroup = {
	getGroupList() {
		return http.get('/list');
	},
};
